import { GitMerge } from "lucide-react";

import { CrmPetDiagnosisController } from "../../../../services/controllers/crmPetDiagnosis";
import { useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import { formatNumber } from "../helpers";
import { EmptyState } from "../components/EmptyState";
import { FunnelStage } from "./FunnelStage";
import { SectionCard } from "../components/SectionCard";
import { SectionError } from "../components/SectionError";

export function RecoveryFunnel() {
  const controller = CrmPetDiagnosisController();
  const kpis = useCrmPetDiagnosis((state) => state.data.overviewKpis);
  const contactedKpis = useCrmPetDiagnosis((state) => state.data.overviewContactedKpis);
  const loading = useCrmPetDiagnosis((state) => state.data.loading);
  const errors = useCrmPetDiagnosis((state) => state.data.errors);

  const stages = [
    { label: "Oportunidades", value: kpis?.attempts, className: "bg-scale-600" },
    {
      label: "Clientes contatados",
      value: contactedKpis?.attempts,
      className: "bg-highlights-500",
      showRate: true,
    },
    {
      label: "Tiveram agendamento",
      value: kpis?.scheduledCustomers,
      className: "bg-primary",
      showRate: true,
    },
    {
      label: "Finalizaram atendimento",
      value: kpis?.finishedCustomers,
      className: "bg-success",
      showRate: true,
    },
    {
      label: "Compraram produtos",
      value: kpis?.purchaseCustomers,
      className: "bg-secondary",
      showRate: true,
    },
  ];

  return (
    <SectionCard
      title="Funil de recuperação"
      description="Clientes contatados são tentativas distintas com contactCount maior que zero."
      icon={GitMerge}
    >
      {errors.overviewKpis && (
        <SectionError
          message={errors.overviewKpis}
          onRetry={() => controller.retrySection("overviewKpis")}
        />
      )}
      {!errors.overviewKpis && errors.overviewContactedKpis && (
        <SectionError
          message={errors.overviewContactedKpis}
          onRetry={() => controller.retrySection("overviewContactedKpis")}
        />
      )}
      {!errors.overviewKpis && loading.overviewKpis && (
        <div className="h-56 animate-pulse rounded-md bg-gray-100" />
      )}
      {!errors.overviewKpis && !loading.overviewKpis && !kpis && (
        <EmptyState title="Sem indicadores de recuperação" />
      )}
      {!errors.overviewKpis && !loading.overviewKpis && kpis && (
        <div className="space-y-5">
          {loading.overviewContactedKpis && (
            <p className="text-sm text-gray-500">Atualizando clientes contatados...</p>
          )}
          {stages.map((stage) => (
            <FunnelStage key={stage.label} stage={stage} total={kpis.attempts} />
          ))}
          <div className="grid grid-cols-2 gap-3 border-t border-gray-200 pt-4 text-sm text-gray-600">
            <span>Reagendados: <strong>{formatNumber(kpis.rescheduledCustomers)}</strong></span>
            <span>Cancelados: <strong>{formatNumber(kpis.canceledCustomers)}</strong></span>
          </div>
        </div>
      )}
    </SectionCard>
  );
}
